import parseDialogue from "../../util/parseDialogue";

export const SuperphreakL5 = parseDialogue(`
superphreak:l5:100-500

#100 Nice work. You keep going at this rate, you may just be an elite agent yet. Welcome to Level 3.
>200 Thanks. So what's up?
>201 How's the S.M.A.R.T system?

#200 I'm starting to see a strong pattern throughout the net. These intrusions and corruptions aren't isolated incidents.
>300 That doesn't sound good.

#201 Still a wreck. We're going off-line like every few minutes. It's all I can do to keep communicating.
>301 Hang in there.

#300 And S.M.A.R.T is still going down every few minutes. It all adds up to some kind of big conspiracy.
>400 Like what?
>401 What can I do to help?

#301 I'll do my best. With all these corrupt programs squirming around, I've got a feeling something big is going on.
>400 Like what?
>401  What can I do to help?

#400 Like something that's going to damage the whole net. Keep looking around. I'll upgrade you to security level three now.
>500 Ready for security level upgrade.

#401 Starting snooping around. Whatever this is, it's going to affect the entire net. I'll upgrade you to security level three now.
>500 Ready for security level upgrade.
`);
